// PhaseFilter Component

import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import classnames from 'classnames'

import IconButton from '../../../common/icon_button/icon_button.jsx'
import IntlMessage from '../../../../common/common/intl/intl_message.jsx'

class PhaseFilter extends PureComponent {
  static get propTypes () {
    return {
      onChangeActivity: PropTypes.func,
      filters: PropTypes.array,
      active: PropTypes.array,
      onChange: PropTypes.func
    }
  }

  static get defaultProps () {
    return {
      onChangeActivity: null,
      filters: [],
      active: [],
      onChange: null
    }
  }

  render () {
    const { active, filters } = this.props

    return (
      <div className='phase-filter'>
        <div className='filter-type'>
          <div className='label'>
            <IntlMessage ident='project.budgetContent.filterLabel' />
          </div>
          {filters.map(filter => {
            const { ident, className, ...others } = filter
            const isActive = active.indexOf(ident) >= 0

            return (
              <IconButton
                key={ident}
                {...others}
                onClick={this._onToggleFilter.bind(this, ident)}
                className={classnames('pfilterbutton', className, {
                  active: isActive
                })}
                type={isActive ? 'default' : 'invert'}
              />
            )
          })}
        </div>
      </div>
    )
  }

  _onToggleFilter = ident => {
    const { active, onChange } = this.props

    if (active.indexOf(ident) >= 0) {
      _.remove(active, activeIdent => activeIdent === ident)
    } else {
      active.push(ident)
    }

    if (onChange) {
      onChange(active)
    }
  }
}

export default PhaseFilter
